var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-card pa-2",staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.item.str))])}
var staticRenderFns = []

export { render, staticRenderFns }